import React from "react";

import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";

import Page from "src/components/Page";
import View from "./customerList";
import PageHeader from "../components/PageHeader";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));


const Index = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Customer List"
    >
      <Container maxWidth="lg">

        <PageHeader
          title="Customer List"
          subtitle="View and manage customer information"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>

      </Container>
    </Page>
  );
};


export default Index;